export const retrieveErrorMsg = (err: any) => {
  const errs = err?.response.data.errors
  if (errs?.length) {
    return errs[0].detail
  }
}
